import { resolveMediaUrl } from './mediaUrl';
import { resolveUserAvatarUrl, resolveUserDisplayName } from './userIdentity';
import { isSuggestedFeedItem } from './feedSuggestion';

const isBandRelatedObject = (relatedObject) => (
  relatedObject
  && typeof relatedObject === 'object'
  && String(relatedObject.objectType || '').trim().toUpperCase() === 'BAND'
);

export const isPostOwnedByViewer = (post, currentUserId) => {
  if (typeof post?.ownedByViewer === 'boolean') {
    return post.ownedByViewer;
  }
  return Boolean(currentUserId && post?.userId && String(currentUserId) === String(post.userId));
};

export const resolvePostCardIdentity = (post, currentUserId, options = {}) => {
  const readOnly = options.readOnly === true;
  const relatedBand = isBandRelatedObject(post?.relatedObject) ? post.relatedObject : null;
  const displayName = relatedBand?.name
    || resolveUserDisplayName(post?.author)
    || post?.title
    || '';
  const rawAvatarUrl = relatedBand?.profilePicture || resolveUserAvatarUrl(post?.author) || null;

  return {
    displayName,
    avatarUrl: rawAvatarUrl ? resolveMediaUrl(rawAvatarUrl) : null,
    enableProfilePreview: !relatedBand && Boolean(post?.userId),
    showSuggestedBadge: isSuggestedFeedItem(post),
    showOwnerBadge: !relatedBand && !readOnly && isPostOwnedByViewer(post, currentUserId),
    relatedBand,
  };
};
